import $ from 'jquery';
import radio from 'radio';
import componentLoader from 'shared/utils/component-loader';
import { PAGE_READY } from 'shared/enums/events';
import eventHandlers from './event-handlers';
import Accordion from '@10up/component-accordion';
// Add jQuery and TimeInc namespace to the global scope.
window.$ = $;
window.jQuery = $;
window.TimeInc = window.TimeInc || {};

$(() => {
  // Set this so that by default $.getScript will not append
  // timestamps to script src requests.
  $.ajaxSetup({ cache: true });

  // Register global event handlers.
  eventHandlers();

  // Activate components.
  componentLoader.load();

  // Let the application know the page is ready.
  radio(PAGE_READY).broadcast();

  // FAQ Accordion
  if ( $('.wp-block-yoast-faq-block') ){

    // pre-format the accordion with the proper classes and schema
    $( '.schema-faq-section' ).each(function(){
      let question = $(this).find('.schema-faq-question');

      // remove the empty paragraphs that yoast is inserting
      $(this).find( 'p:empty' ).remove();

      // format markup schema
      $(this).find('.schema-faq-answer').addClass('accordion-content');

      // Add Classes that accordion library expects
      question.addClass('accordion-header');

      // Remove parent for Accordions expected schema
      $(question).unwrap();
    })

    //Initialize Accordion
    new Accordion( '.wp-block-yoast-faq-block', {
      onCreate: function() {
        // On Create
      },
      onOpen: function() {
        // On Open
      },
      onClose: function() {
        // On Close
      },
      onToggle: function() {
        // On Toggle
      }
    } );
  }
});

// WEBPACK FOOTER //
// ./~/unicorn/public/src/main.js
